import { render, staticRenderFns } from "./Tooltipp.vue?vue&type=template&id=348ce9fb"
import script from "./tooltipp.ts?vue&type=script&lang=js&external"
export * from "./tooltipp.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports